/**
 * First-Time Event Tracker
 * Uses localStorage to track first-time events per device
 */

const STORAGE_KEY_PREFIX = "artha_first_time_";

// Using regular enum since we need Object.values() for reset
enum FirstTimeEventKey {
  PROFILE_SHARE = "profile_share",
  JOB_SHARE = "job_share",
}

/**
 * Check if this is the first time for a specific event
 */
function isFirstTime(eventKey: FirstTimeEventKey): boolean {
  if (typeof window === "undefined") return false;

  const key = `${STORAGE_KEY_PREFIX}${eventKey}`;
  return localStorage.getItem(key) !== "true";
}

/**
 * Mark an event as completed (no longer first time)
 */
function markAsCompleted(eventKey: FirstTimeEventKey): void {
  if (typeof window === "undefined") return;

  const key = `${STORAGE_KEY_PREFIX}${eventKey}`;
  localStorage.setItem(key, "true");
}

/**
 * Check if profile share is first time
 */
export function isFirstProfileShare(): boolean {
  return isFirstTime(FirstTimeEventKey.PROFILE_SHARE);
}

/**
 * Mark profile share as completed
 */
export function markProfileShareCompleted(): void {
  markAsCompleted(FirstTimeEventKey.PROFILE_SHARE);
}

/**
 * Check if job share is first time
 */
export function isFirstJobShare(): boolean {
  return isFirstTime(FirstTimeEventKey.JOB_SHARE);
}

/**
 * Mark job share as completed
 */
export function markJobShareCompleted(): void {
  markAsCompleted(FirstTimeEventKey.JOB_SHARE);
}

/**
 * Reset all first-time flags (useful for testing)
 */
export function resetFirstTimeFlags(): void {
  if (typeof window === "undefined") return;

  Object.values(FirstTimeEventKey).forEach((key) => {
    localStorage.removeItem(`${STORAGE_KEY_PREFIX}${key}`);
  });
}
